module.exports = {
  ...require('./talona'),
  ...require('./talos'),
  ...require('./tempus'),
  ...require('./tiamat'),
  ...require('./torm'),
  ...require('./tymora'),
  ...require('./tyr'),
}
